import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=215452b4"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=215452b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports